module.exports = __webpack_public_path__ + "static/media/main idea.c060efc1.mp3";